<script>
import { globalComputed } from '@store/helpers'

export default {
  components: {},
  props: {
    mainColor: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isMobile: false,
    }
  },
  computed: {
    ...globalComputed,
    styleObject: function() {
      return {
        '--background-color-hover': this.mainColor,
        color: this.mainColor,
      }
    },
    foramtLineId() {
      return (this.currentSetting.lineId || '').replace('@', '')
    },
  },
  mounted() {
    if (window.innerWidth < 992) {
      this.isMobile = true
    }
  },
  methods: {},
}
</script>
<template>
  <div class="footer" :style="styleObject">
    <div class="iconBox">
      <a v-if="currentSetting.fbFanpageUrl" :href="currentSetting.fbFanpageUrl" target="_blank" class="text-decoration-none socialMenu__item borderColor" :style="styleObject">
        <i class="fab fa-facebook-square"></i>
        <span class="sr-only">facebook</span>
      </a>
      <a v-if="currentSetting.lineId" :href="`https://line.me/R/ti/p/%40${foramtLineId}`" target="_blank" class="text-decoration-none socialMenu__item borderColor" :style="styleObject">
        <i class="fab fa-line"></i>
        <span class="sr-only">line</span>
      </a>
      <a v-if="currentSetting.podcast" :href="currentSetting.podcast" target="_blank" class="text-decoration-none socialMenu__item borderColor" :style="styleObject">
        <i class="far fa-podcast"></i>
        <span class="sr-only">podcast</span>
      </a>
      <a v-if="currentSetting.youtubeUrl" :href="currentSetting.youtubeUrl" target="_blank" class="text-decoration-none socialMenu__item borderColor" :style="styleObject">
        <i class="fab fa-youtube"></i>
        <span class="sr-only">youtube</span>
      </a>
    </div>
    <div class="imgBox">
      <img class="img" src="~@assets/images/TechInside/01logo_grey1.png" alt="" />
    </div>
    <p>© 零壹科技股份有限公司 2023, All Rights Reserved</p>
  </div>
</template>
<style lang="scss" scoped>
.footer {
  position: relative;
  margin-top: 320px;
  height: 280px;
  border-top: 2px solid var(--background-color-hover);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  @include max-sm {
    margin-top: 180px;
  }
  > p {
    font-size: 16px;
    color: $color-gray-8;
    font-weight: 400;
    margin: 0;
    text-align: center;
  }
  .iconBox {
    margin-bottom: 20px;
  }
  .borderColor {
    color: var(--background-color-hover);
    border: 1px solid var(--background-color-hover);
    &:hover {
      color: $color-gray-1 !important;
      background-color: var(--background-color-hover);
    }
  }
  .imgBox {
    position: absolute;
    right: -8%;
    bottom: -55%;
    @include max-xl {
      right: -12%;
    }
    @include max-lg {
      right: -16%;
      bottom: -30%;
    }
    @include max-md {
      display: none;
    }

    .img {
      width: 550px;
      height: 400px;
      @include max-lg {
        width: 450px;
        height: 300px;
      }
    }
  }
}
</style>
